import * as React from "react";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../../../api";
import classnames from "classnames";
import { Controller, useForm } from "react-hook-form";
import { DragDropFile } from "../../../../components/upload";
import { GalleryPopupSettings } from "../../components/gallery-popup";
import { Multiselect } from "react-widgets";
import { toastr } from "react-redux-toastr";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { decodeHtmlEntities } from "../../../../utils/common";

interface ImageDetails {
  isOpen: boolean;
  details: {
    location: string; size: number; originalname: string; propertyTypes: string[]; _id: string
  } | null
}

const ProposalCoverImage: React.FunctionComponent = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [openGallery, setOpenGallery] = React.useState(false);
  const [isOpenDetails, setIsOpenDetails] = React.useState<boolean>(false);
  const [propertyType, setPropertyType] = React.useState<any[]>([]);
  const [selectedFilters, setSelectedFilters] = React.useState<string[]>([]);
  const [filtered, setFiltered] = React.useState<string[] | null>(null);
  const [searchInputValue, setSearchInputValue] = React.useState<string>('');

  const { control, handleSubmit, errors, setValue, watch } = useForm<any>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const { data: proposalCoverImages, reload } = useDataLoader<any[]>((updatedFilter: any[]) =>
    api.proposal.loadAllProposalCoverImages(updatedFilter)
  );

  const onSubmit = async (data: any) => {
    const response = await api.proposal.addProposalImages({
      ...data?.file,
      propertyTypes: data?.propertyTypes,
    });

    if (response.status === 200) {
      reload()
      setIsOpenDetails(false)
      toastr.success("Success", `Proposal image added successfully`);
    } else {
      toastr.error("Error", "Unable to add cover image");
    }
  };

  const onDelete = async (id: string) => {
    const response = await api.proposal.deleteProposalCoverImage(id);

    if (response.status === 200) {
      reload()
      setIsOpenDetails(false)
      toastr.success("Success", `Proposal image deleted successfully`);
    } else {
      toastr.error("Error", "Unable to delete proposal cover image");
    }
  }

  const onFilter = async () => {
    setFiltered(null)
    setSearchInputValue('')
    reload(selectedFilters)
    setIsOpen(false);
  }

  React.useEffect(() => {
    const handlePropertyType = async () => {
      try {
        const propertyTypeData = await api.AddNewRequirement.getPropertyType();
        // let propertyTypeOptions = propertyTypeData?.map((item: CityLocation) => ({
        //     value: item.cityDetailsID,
        //     name: item.cityLocName,
        // }));

        const subTypes = propertyTypeData.reduce((acc: any, item: any) => {
          acc.push(
            ...item.subTypes.map(
              (subType: { _id: any; propertyTypeName: any }) => 
              //   ({
              //   _id: subType._id,
              //   name: decodeHtmlEntities(subType.propertyTypeName),
              // })
              decodeHtmlEntities(subType.propertyTypeName)
            )
          );
          return acc;
        }, []);
        setPropertyType(subTypes);
        // setValue('preferredLocations', []);
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }
    };

    handlePropertyType()
  }, [])

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right proposal-cover-center">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Proposal Cover Image</h4>
          </div>
          <div className="col-auto text-right">
            <button className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center" onClick={() => {
              setIsOpenDetails(true)
              setTimeout(() => {
                setValue('file', null)
                setValue('propertyTypes', null)
              }, 0);
            }}>
              <i className="icon-plus mr-1 font-xs"></i> Add
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th className="font-weight-normal" style={{ width: "10%" }}>
                  <span className="d-inline-flex align-items-center">
                    Image
                  </span>
                </th>
                <th className="font-weight-normal">
                  <span className="d-inline-flex align-items-center">Property Type</span>
                </th>
                <th align="center" className="font-weight-normal">
                  <div className="d-flex justify-content-end align-items-center">
                    {selectedFilters.length ? <span role="button" className="text-decoration-underline btn-link mr-1" onClick={(e) => {
                      e.stopPropagation()
                      setSelectedFilters([])
                      setFiltered(null)
                      setSearchInputValue('')
                      reload([])
                    }
                    }>Clear</span> : null}
                    <span className="d-flex justify-content-center position-relative">
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setIsOpen(!isOpen);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="26"
                          viewBox="0 0 28 26"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8 8.8C8 8.35817 8.35817 8 8.8 8H19.2C19.6418 8 20 8.35817 20 8.8C20 9.24183 19.6418 9.6 19.2 9.6H8.8C8.35817 9.6 8 9.24183 8 8.8ZM10 12.8C10 12.3582 10.3582 12 10.8 12H17.2C17.6418 12 18 12.3582 18 12.8C18 13.2418 17.6418 13.6 17.2 13.6H10.8C10.3582 13.6 10 13.2418 10 12.8ZM12.8 16C12.3582 16 12 16.3582 12 16.8C12 17.2418 12.3582 17.6 12.8 17.6H15.2C15.6418 17.6 16 17.2418 16 16.8C16 16.3582 15.6418 16 15.2 16H12.8Z"
                            fill="#0F1312"
                          />
                        </svg>


                      </div>
                      <div
                        className={classnames({
                          "dropdown-menu dropdown-shadow font-xs border-0 w-100 p-0 ": true,
                          in: isOpen,
                        })}
                      >
                        <div className="input-group border-bottom">
                          <input
                            type="text"
                            className="form-control border-0 pr-0"
                            placeholder="Search"
                            value={searchInputValue}
                            onChange={(e)=> {
                              setSearchInputValue(e?.target?.value);
                              if(e.target.value){
                                setFiltered(propertyType?.filter(type=>type?.toLowerCase()?.startsWith(e?.target?.value.toLowerCase())))
                              }else{
                                setFiltered(null)
                              }
                            }}
                          />
                        </div>
                        <div className="position-relative">
                          <ul
                            className={classnames({
                              "list-unstyled  m-0 font-weight-semibold": true,
                            })}
                          >
                            {[...(filtered === null ? propertyType : (filtered || []) )].map((filter, index) => {
                              return (
                                <li
                                  key={index}
                                  className="border-bottom"
                                  style={{ padding: "12px 10px" }}
                                >
                                  <input
                                    type="checkbox"
                                    name="proposal_filter"
                                    id={`filter_${filter}`}
                                    checked={selectedFilters.includes(filter)}
                                    onClick={() => {
                                      if (selectedFilters.includes(filter)) {
                                        setSelectedFilters(prev => prev.filter(item => item !== filter))
                                      } else {
                                        setSelectedFilters(prev => [...prev, filter])
                                      }
                                    }}
                                  />
                                  <label
                                    htmlFor={`filter_${filter}`}
                                    className="font-xs font-weight-semibold"
                                  >
                                    {filter}
                                  </label>
                                </li>
                              );
                            })}
                          </ul>
                          <div className="px-3 py-3 text-right">
                            <button
                              type="button"
                              onClick={onFilter}
                              className="btn btn-primary py-2 px-4 font-weight-semibold"
                            >
                              <span className="px-2">Apply</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </span>

                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {proposalCoverImages?.map((image, index) => {
                return (
                  <tr key={index} role="button" onClick={() => {
                    setIsOpenDetails(true)
                    setTimeout(() => {
                      setValue('file', { ...image.media, coverImageId: image._id })
                      setValue('propertyTypes', image.propertyTypes.length === 0 ? null : image.propertyTypes)
                    }, 0);
                  }}>
                    <td>
                      <figure className="mb-0">
                        <img
                          src={image?.media?.location}
                          className="img-fluid w-100 h-100"
                        />
                      </figure>
                    </td>
                    <td colSpan={2}>
                      <address className="mb-0">
                        {image?.propertyTypes?.join(', ')}
                      </address>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      {isOpenDetails &&
        <div className="col-lg col-md-6 col-12 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
          <div className="px-4 py-4">
            <h3 className="font-lg font-weight-bold pb-2 pt-3">Create Image</h3>
            {watch('file') && <>
              <label className="font-normal font-weight-semibold">Image</label>
              <ul className="upload-img-list pl-0 list-unstyled mb-0">
                <li className="border d-flex align-items-center mb-2">
                  <figure className="mb-0">
                    <img src={watch('file')?.location} className="img-fluid w-100 h-100" />
                  </figure>
                  <figcaption className="mb-0 d-flex justify-content-between w-100 align-items-center">
                    <div>
                      {" "}
                      <h6 className="font-normal font-weight-semibold mb-0 pb-1">
                        {watch('file')?.originalname}
                      </h6>
                      <p className="font-normal text-muted mb-0">{(watch('file')?.size / (1024 * 1024))?.toFixed(2)} MB</p>
                    </div>
                    <div>
                      <span
                        className="text-primary font-normal font-weight-semibold mr-3 cursor-pointer"
                        onClick={() => setOpenGallery(true)}
                      >
                        View
                      </span>
                      <span className="mr-2 close cursor-pointer" onClick={() => {
                        setValue('file', null)
                        // setValue('propertyTypes', null)
                      }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M1.25 1.04688L14.75 14.5469"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M1.25 14.5469L14.75 1.04688"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </figcaption>
                </li>
              </ul>
            </>}
            <div className={(watch('file')) ? "mb-4 d-none" : "mb-4"}>
              <Controller
                control={control}
                rules={{
                  required: "Image is required",
                }}
                name="file"
                render={({ onChange, value, name }) => (
                  <DragDropFile
                    key={watch('file')}
                    value={value}
                    name={'cover image'}
                    id={'coverImage'}
                    checkDimensions
                    onFileChosen={onChange}
                    title={'Drag & Drop files here'}
                    accept={[".png", ".jpeg", '.jpg']}
                  />
                )}
              />
              <ErrorMessage>{errors?.file?.message}</ErrorMessage>
            </div>
            <div className="form-group">
              <label className="font-normal font-weight-semibold">
              Property Type<span className="text-red">*</span>
              </label>
              <Controller
                control={control}
                rules={{
                  required: "tags is required",
                }}
                name="propertyTypes"
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={propertyType}
                    // textField={'name'}
                    // valueField={'_id'}
                    placeholder={'Select Property Type'}
                    onChange={(data) => {
                      onChange(data)
                    }}
                    allowCreate="onFilter"
                  />
                )}
              />
              <ErrorMessage>{errors?.propertyTypes?.message}</ErrorMessage>
            </div>
            <div>
              <div className="form-group font-weight-semibold mb-4 text-right pt-1">
                <button className="btn border-secondary py-2 font-weight-semibold font-normal px-3" onClick={() => onDelete(watch('file')?.coverImageId)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="14"
                    viewBox="0 0 11 14"
                    fill="none"
                  >
                    <path
                      d="M2.75 13.1923C2.24483 13.1923 1.81725 13.0173 1.46725 12.6673C1.11725 12.3173 0.94225 11.8897 0.94225 11.3845V2.69225H0.75C0.5375 2.69225 0.359333 2.62033 0.2155 2.4765C0.0718332 2.33267 0 2.1545 0 1.942C0 1.72933 0.0718332 1.55125 0.2155 1.40775C0.359333 1.26408 0.5375 1.19225 0.75 1.19225H3.8075V0.8845C3.8075 0.639667 3.89375 0.431083 4.06625 0.258749C4.23875 0.0862494 4.44742 0 4.69225 0H6.19225C6.43708 0 6.64575 0.0862494 6.81825 0.258749C6.99058 0.431083 7.07675 0.639667 7.07675 0.8845V1.19225H10.1345C10.347 1.19225 10.5251 1.26417 10.6687 1.408C10.8126 1.55183 10.8845 1.73 10.8845 1.9425C10.8845 2.15517 10.8126 2.33325 10.6687 2.47675C10.5251 2.62042 10.347 2.69225 10.1345 2.69225H9.94225V11.3845C9.94225 11.8897 9.76725 12.3173 9.41725 12.6673C9.06725 13.0173 8.63967 13.1923 8.1345 13.1923H2.75Z"
                      fill="#6F7171"
                    />
                  </svg>
                </button>
                <button
                  className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4"
                  style={{ margin: "0 10px" }}
                  onClick={() => setIsOpenDetails(false)}
                >
                  Cancel
                </button>

                <button
                  style={{ padding: "8px 33px" }}
                  className="btn btn-primary py-2 font-weight-semibold font-normal text-uppercase"
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>}
      {openGallery && watch('file')?.location && (
        <GalleryPopupSettings imageUrl={watch('file')?.location} imageName={watch('file')?.originalname} onClose={() => setOpenGallery(false)} />
      )}
    </>
  );
};

export default ProposalCoverImage;
